import Button from "../../button/button";
// import Typography from "../../typography/typography";
import { ActionProps } from "react-querybuilder";
import { Trash } from "../../icons";

const RemoveGroupAction = (props: ActionProps) => {
  const { handleOnClick } = props;

  return (
    <Button
      className="filterGrp-remove-btn"
      variant="outlined"
      onClick={handleOnClick}
      sx={({palette}) => ({
        marginRight: "0px",
        marginLeft: "auto",
        color: `${palette.theme.error?.[600]} !important`
      })}
      startIcon={<Trash color="theme.error.600" fontSize="small"/>}
    >
      Delete Group
    </Button>
  );
};

export { RemoveGroupAction };
export default RemoveGroupAction;
